import { datadogRum } from '@datadog/browser-rum'
import { is } from 'valibot'

export default defineNuxtPlugin(
  (app) => {
    if (import.meta.env.PROD) {
      const { analytics } = useCookieConsent()

      datadogRum.init({
        ...app.$config.public.datadog,
        defaultPrivacyLevel: 'mask-user-input',
        sessionSampleRate: 100,
        beforeSend: event => !is(ignoredErrorSchema, event.error),
        trackingConsent: analytics.value ? 'granted' : 'not-granted',
      })

      watch(analytics, (granted) => {
        datadogRum.setTrackingConsent(granted ? 'granted' : 'not-granted')
      })
    }
  },
)
